import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acesso-restrito',
  templateUrl: './acesso-restrito.component.html',
  styleUrls: ['./acesso-restrito.component.css']
})
export class AcessoRestritoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
